module.exports = __webpack_public_path__ + "img/gh-30282-7.prt.992b97a3.jpg";